export default "__VITE_ASSET__166052ec__"